import { createInstance as e } from "i18next";
import { initI18nInstance as r } from "./index26.mjs";
const a = (n) => {
  const t = e();
  return r(t, n);
};
export {
  a as createI18nInstance
};
